import { set, toggle } from '@/utils/vuex'
import { idiomas } from '@/i18n.js';
import i18n from '@/i18n.js';

export default {
	setCargadoComponenteApp: set('cargadoComponenteApp'),
	setDrawer: set('drawer'),
	setImage: set('image'),
	setColor: set('color'),
	setTotem: set('totemConfig'),
	toggleDrawer: toggle('drawer'),
	setTitle: set('titlePage'),
	setModoGeneral: set('modoGeneral'),
	setDialogLogin(state, val) {
		state.dialogLogin = val;
	},
	setLoading(state, val) {
		state.loading = val;
	},
	setLoadingComunes(state, val) {
		state.loadingComunes = val;
	},
	setDialogReiniciarPedido(state, val) {
		state.dialogReiniciarPedido = val;
	},
	setDialogFinalizar(state, val) {
		state.dialogFinalizar = val;
	},
	setDialogIdiomas(state, val) {
		state.dialogIdiomas = val;
	},
	setDialogCambio(state, val) {
		state.dialogCambio = val;
	},
	setCartDrawer(state, val) {
		state.cartDrawer = val;
	},
	setWindowOrientation(state, val) {
		state.windowOrientation = val;
	},
	setIsTablet(state, val) {
		state.isTablet = val;
	},
	setIsMobile(state, val) {
		state.isMobile = val;
	},
	setIsSafari(state, val) {
		state.isSafari = val;
	},
	setLang(state, val) {
		let txt = '';
		idiomas.forEach(function (e, i) {
			if (e.locale == val) {
				txt = e.nombre;
			}
		})
		i18n.locale = val;
		state.lang = {
			key: val,
			value: txt
		}
	},
	setInternetConnection(state, val) {
		state.internetConnection = val;
	},
	setNegocio(state, n) {
		state.negocioObj = n;
	},
	setRouter(state, r) {
		state.router = r;
	},
	setCookiesNav(state, v) {
		state.cookiesNav = v;
	},
	setCookiesAccept(state, v) {
		state.cookiesAccept = v;
	},
	setModoDesarrollo(state, modo) {
		state.modoDesarrollo = modo;
	}
}